const ProgramFirstLoad = async (setProgram, programs, setSplitProgram) => {
  try {
    let loadId = sessionStorage.getItem("program_id");

    if (loadId) {
      const program = programs?.find((p) => p?._id === loadId);
      setProgram(program);
    }
    if (programs) {
      const wash = programs?.find((p) => p?._id === "6310a054f095c39af2b7503e");
      const shoe = programs?.find((p) => p?._id === "6310a3d1f095c39af2b75045");
      const iron = programs?.find((p) => p?._id === "6310a3cff095c39af2b75041");
      setSplitProgram({ wash, shoe, iron });
    }
  } catch (error) {
    console.error("ProgramFirstLoad  :", error);
  }
};

export default ProgramFirstLoad;
